import React from 'react'
import Modal from 'react-responsive-modal'

import Text from 'components/common/Text'
import { Color } from 'constants/color'

import { ModalContent, modalStyles } from './styles'

const IncognitoError = ({ isModalOpen, onCloseModal }) => {
    return (
        <Modal
            styles={modalStyles}
            showCloseIcon
            isModalOpen={isModalOpen}
            onCloseModal={onCloseModal}
        >
            <ModalContent>
                <Text level="3" color={Color.ohGrey}>
                    {"Oops, you can't use Jeopardy in incognito mode"}
                </Text>
            </ModalContent>
        </Modal>
    )
}

export default IncognitoError
